import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toLower from 'lodash/toLower';
import PropTypes from 'prop-types';
// Core components
import RadioGroup from 'components/core/RadioGroup';
import Tooltip from 'components/core/Tooltip';
// Custom
import { countryShape } from 'constants/PropTypesShapes';
import { FlagImg } from 'components/img/AssetImg';
import { DisabledContext } from 'components/misc/Contexts';

const CountryFilter = ({ countries, value, onChange }) => (
  <div className="d-flex align-items-center w-100">
    <div className="pr-3 hidden-sm-down">
      <LocalizedMessage id="info.countryFilter" />
    </div>
    <DisabledContext.Consumer>
      {(disabled) => (
        <RadioGroup
          disabled={disabled}
          value={value}
          items={[
            {
              key: 'all',
              value: 'all',
              label: (
                <div>
                  <LocalizedMessage id="info.all" values={{ gender: 'male' }} />
                </div>
              ),
            },
            ..._map(countries, ({ code }) => (
              {
                key: code,
                value: code,
                label: (
                  <Tooltip
                    content={<LocalizedMessage id={`country.${_toLower(code)}`} />}
                    style={{ marginTop: '-2px' }}
                  >
                    <FlagImg countryCode={code} />
                  </Tooltip>
                ),
              }
            )),
          ]}
          row
          onChange={onChange}
        />
      )}
    </DisabledContext.Consumer>
  </div>
);

CountryFilter.propTypes = {
  countries: PropTypes.arrayOf(countryShape),
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

CountryFilter.defaultProps = {
  countries: null,
  value: 'all',
};

const mapStateToProps = (state) => ({
  countries: state.country.known,
});

module.exports = connect(
  mapStateToProps,
  null,
)(CountryFilter);



// WEBPACK FOOTER //
// ./components/filters/CountryFilter.js